<template>
  <div class="yearSale">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <!-- 表单区域 -->
          <BaseInfoAgreement
            ref="formItem"
            :fetchData="baseFormData"
            :isDisabledPricingRule="isDisabledPricingRule"
            :contractStatus="contractStatus"
            @isRestrict="isRestrict"
          />
        </div>
      </el-collapse-item>

      <el-collapse-item name="2">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            产品明细
          </div>
        </template>
        <div class="collapse-content">
          <!--产品明细-->
          <div class="prodcut">
            <el-tabs type="card" v-model="tabActiveName" class="common-tab">
              <el-tab-pane label="产品明细" name="first">
                <div class="detail">
                  <ShopDetailAgreementTable
                    ref="agreementTable"
                    :orderDetailList="orderDetailList"
                    :contractStatus="contractStatus"
                    :baseFormData="baseFormData"
                    @closeTableHandler="closeTableHandler"
                    @tableDeleteNotifier="tableDeleteNotifier"
                  />
                </div>
              </el-tab-pane>
              <el-tab-pane label="关联合同" name="fourth">
                <div class="detail">
                  <relation-info
                    :isEdit="isEdit"
                    ref="relationInfo"
                    :contractStatus="contractStatus"
                    :defaultData="orderContractRelationshipList"
                  >
                  </relation-info>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </el-collapse-item>
      <!--附件-->
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <!-- <upload ref="upload" @upload="handleUpload" /> -->
          <FileTable
            ref="fileTableRef"
            :attachments="attachments"
            :isShowDownBtn="
              contractStatus != '' && contractStatus != 'ZT06' && contractStatus != 'ZT05'
            "
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮组 -->
    <AgreementBtn @btnHandler="btnClickHandler" :contractStatus="contractStatus" />
  </div>
</template>
<script>
  import relationInfo from '../../components/relation-info';
  import { dateFormatter } from '@/common/js/util';
  import saleAgreementCreationMixin from './saleAgreementCreationMixin.js';
  import ShopDetailAgreementTable from './components/ShopDetailAgreementTable/index.vue';
  import BaseInfoAgreement from './components/BaseInfoAgreement/index.vue';
  import AgreementBtn from './components/FooterBtnGroup/AgreementBtn.vue';
  import wumaoMixins from '@/common/mixins/wumaoMixins';
  export default {
    name: 'wumaoSaleAgreementCreation',
    components: {
      relationInfo,
      ShopDetailAgreementTable,
      BaseInfoAgreement,
      AgreementBtn,
    },
    mixins: [saleAgreementCreationMixin, wumaoMixins],
    data() {
      return {
        selectCompanyCode: '',
        isSales: true, //销售是sales，采购是purchase,标志符true代表传sales
        fileType: 'agreement',
        activeNames: ['1', '2', '3', '4'],
        tabActiveName: 'first',
        pricingRule: true,
        pricingRuleDisabled: false,
        params: {
          contractNo: null,
          contractValidStart: null,
          contractValidEnd: null,
          contractCreateDate: dateFormatter(new Date()),
          contractBusinessDepartment: null,
          contractBusinessDepartmentName: null,
          supplierNo: null,
          supplierName: null,
          customer: null,
          customerNo: null,
          customerName: null,
          payerNo: null,
          payerName: null,
          contractOperaterNo: null,
          contractOperaterName: null,
          contractSalesman: null,
          contractSalesmanNo: null,
          contractSalesmanName: null,
          externalContractNo: null,
          tradeType: 'MY01',
          businessType: 'YDYW01',
          isDiscount: 1,
          isNeedMonthlyContract: 1,
          isFixedPrice: '1',
          pricingRule: null,
          businessOrder: null,
          supplychain: null,
          supplychainNo: null,
          supplychainName: null,
          contractCurrency: 'CNY',
          contractCurrencyName: '',
          contractCurrencyExchangeRate: 1,
          companyCurrency: null, //公司本币
          companyCurrencyName: null,
          orderDetailList: [],
          orderContractRelationshipList: [],
          orderDetailDelIds: [],
        },
        remark: {
          mark: null,
        },
        //附件
        uploadTableData: [],
        load: false,
        localCurrency: {}, //本币
        attachments: [],
      };
    },
    computed: {
      isEdit() {
        return this.$route.query.isEdit ? JSON.parse(this.$route.query.isEdit) : false;
      },
    },
    created() {
      //如果有合同号，说明是从别的合同或者协议创建的
      // if (this.$route.query.contractNo) {
      //   //获取详情
      //   this.getOrderDetail();
      // } else {
      //   //供应商
      //   this.params.supplierNo = this.userInfo.companyCode;
      //   this.params.supplierName = this.userInfo.companyName;
      //   //业务公司赋初值
      //   this.params.contractBusinessCompanyNo = this.userInfo.companyCode;
      //   this.params.contractBusinessCompanyName = this.userInfo.companyName;
      //   //业务部门赋初值
      //   this.params.contractBusinessDepartment = this.userInfo.departmentCode;
      //   this.params.contractBusinessDepartmentName = this.userInfo.departmentName;
      //   //操作人赋初值
      //   this.params.contractOperaterNo = this.userInfo.userCode;
      //   this.params.contractOperaterName = this.userInfo.userName;
      //   //业务员赋初值
      //   this.params.contractSalesmanNo = this.userInfo.userCode;
      //   this.params.contractSalesmanName = this.userInfo.userName;
      //   this.getLegerCode(this.params.supplierNo);
      // }
      // this.selectCompanyCode = this.userInfo.companyCode;
    },
    methods: {
      // 关闭明细表的时候计算金额
      closeTableHandler(tableData = []) {
        // 处理表格中定价选择否的时候
        const isFixedPriceResult = tableData.some((item) => item.isFixedPrice == '0');
        console.log(isFixedPriceResult, '--修改->>');
        //false 定价 true 不定价    1不定价 0定价
        this.baseFormData.isFixedPrice = isFixedPriceResult ? '1' : '0';
        this.isDisabledPricingRule = !isFixedPriceResult;
      },
      // 获取本币名称---供应商
      // async getLegerCode(companyCode) {
      //   if (companyCode) {
      //     let res = await this.$axios.get(API.GET_LEGER_CODE_NAME, { companyCode });
      //     if (res) {
      //       if (res.data.code == 0) {
      //         let data = res.data.data;
      //         if (data) {
      //           //本币
      //           this.localCurrency = {
      //             currencyCode: data.currencyCode,
      //             currencyName: data.currencyName,
      //           };
      //           this.params.companyCurrency = data.currencyCode;
      //           this.params.companyCurrencyName = data.currencyName;
      //           this.params.contractCurrency = this.params.companyCurrency;
      //           this.params.contractCurrencyName = this.params.companyCurrencyName;
      //           this.params.contractCurrencyExchangeRate = 1;
      //         } else {
      //           if (this.params.supplierNo == 'C0328') {
      //             this.params.contractCurrency = null;
      //             this.params.contractCurrencyName = null;
      //           }
      //           this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
      //         }
      //       } else {
      //         this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
      //       }
      //     } else {
      //       this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
      //     }
      //   }
      // },
      // getOrderDetail() {
      //   this.loading.startLoading();
      //   this.$axios
      //     .post(API.GET_ORDER_DETAIL_API, {
      //       contractNo: this.$route.query.contractNo,
      //       copyFlag: this.$route.query.copy ? '0' : '1',
      //       relationContractDetailCategory: 'HT05',
      //     })
      //     .then((res) => {
      //       this.loading.endLoading();
      //       if (res.data.code === 0) {
      //         this.params = Object.assign({}, this.params, res.data.data);
      //         this.selectCompanyCode = res.data.data.supplierNo || this.userInfo.companyCode;
      //         //如果是已保存 和 已驳回状态 可修改页面字段
      //         //是否不定价为否  则定价规则为必填
      //         if (this.params.isFixedPrice == 1) {
      //           this.pricingRule = true;
      //           this.pricingRuleDisabled = false;
      //         } else {
      //           this.pricingRule = false;
      //           this.pricingRuleDisabled = true;
      //         }
      //         //客户
      //         this.params.customer = [
      //           {
      //             customerNo: res.data.data.customerNo || null,
      //             customerName: res.data.data.customerName || null,
      //           },
      //         ];
      //         //业务员
      //         this.params.contractSalesman = [
      //           {
      //             contractSalesmanNo: res.data.data.contractSalesmanNo || null,
      //             contractSalesmanName: res.data.data.contractSalesmanName || null,
      //           },
      //         ];
      //         //供应链主体
      //         this.params.supplychain = [
      //           {
      //             supplychainNo: res.data.data.supplychainNo || null,
      //             supplychainName: res.data.data.supplychainName || null,
      //           },
      //         ];
      //         //业务公司赋初值
      //         this.params.contractBusinessCompanyNo = res.data.data.contractBusinessCompanyNo;
      //         this.params.contractBusinessCompanyName = res.data.data.contractBusinessCompanyName;
      //         //业务部门赋初值
      //         this.params.contractBusinessDepartment =
      //           res.data.data.contractBusinessDepartment || this.userInfo.departmentCode;
      //         this.params.contractBusinessDepartmentName =
      //           res.data.data.contractBusinessDepartmentName || this.userInfo.departmentName;
      //         this.params.contractCreateDate = dateFormatter(new Date());
      //         //操作人赋初值
      //         this.params.contractOperaterNo = this.userInfo.userCode;
      //         this.params.contractOperaterName = this.userInfo.userName;
      //         //业务员赋初值
      //         this.params.contractSalesmanNo = this.userInfo.userCode;
      //         this.params.contractSalesmanName = this.userInfo.userName;
      //         //备注
      //         this.remark.mark = res.data.data.mark ? res.data.data.mark : null;
      //         this.getLegerCode(this.params.supplierNo);
      //         this.$nextTick(() => {
      //           this.$refs.formItem.clearValidate();
      //         });
      //       } else {
      //         this.$alert(res.data.msg);
      //       }
      //     });
      // },
      // //更换币种
      // changeCurrency(obj) {
      //   //业务部门
      //   if (obj.prop == 'contractBusinessDepartment') {
      //     this.params.customer = null;
      //     this.params.customerNo = null;
      //     this.params.customerName = null;
      //     this.params.payerNo = null;
      //     this.params.payerName = null;
      //   }
      //   //贸易类型
      //   if (obj.prop == 'tradeType') {
      //     //更改贸易类型，需要更新产品明细表
      //     this.$refs.product.updateProduct(obj);
      //   }
      //   //甲方-当前账户所属公司
      //   if (obj.prop == 'supplierNo') {
      //     this.params.contractBusinessDepartment = null;
      //     this.params.contractBusinessDepartmentName = null;
      //     this.params.customer = null;
      //     this.params.customerNo = null;
      //     this.params.customerName = null;
      //     this.params.customerType = null;
      //     let item = XEUtils.find(
      //       JSON.parse(this.userInfo.companyList),
      //       (item) => item['personCompanyCode'] === obj.val
      //     );
      //     this.params.supplierNo = obj.val;
      //     this.params.supplierName = item.personCompanyName;
      //     //业务公司取值供应商字段，跟部门联动
      //     this.params.contractBusinessCompanyNo = this.params.supplierNo;
      //     this.params.contractBusinessCompanyName = this.params.supplierName;
      //     this.params.orderDetailList = [];
      //     this.selectCompanyCode = item.personCompanyCode;
      //     this.$refs.product.removeEvent();
      //     this.$refs.formItem.getDepartmentList();
      //     this.getLegerCode(this.params.supplierNo).then(() => {
      //       this.params.contractCurrency = this.params.companyCurrency;
      //       this.params.contractCurrencyName = this.params.companyCurrencyName;
      //     });
      //   }
      //   //乙方-默认为付款单位
      //   if (obj.prop == 'customer') {
      //     //客户-乙方
      //     // this.params.customer = obj.val ? obj.val[0].partnerZhName : null;
      //     this.params.customerNo = obj.val ? obj.val[0].partnerCode : null;
      //     this.params.customerName = obj.val ? obj.val[0].partnerZhName : null;
      //     this.params.customer = [
      //       {
      //         customerNo: this.params.customerNo,
      //         customerName: this.params.customerName,
      //       },
      //     ];
      //     //付款单位
      //     this.params.payerNo = obj.val ? obj.val[0].partnerCode : null;
      //     this.params.payerName = obj.val ? obj.val[0].partnerZhName : null;
      //   }
      //   //业务员
      //   if (obj.prop == 'contractSalesman') {
      //     this.params.contractSalesmanNo = obj.val ? obj.val[0].id : null;
      //     this.params.contractSalesmanName = obj.val ? obj.val[0].personName : null;
      //   }
      //   //付款单位如果修改了，将付款单位no置为空
      //   if (obj.prop == 'payerName') {
      //     this.params.payerNo = null;
      //     if (this.params.customer && obj.val == this.params.customer[0].partnerZhName) {
      //       this.params.payerNo = this.params.customer[0].partnerCode;
      //     }
      //   }
      //   //定价规则
      //   if (obj.prop == 'isFixedPrice') {
      //     if (obj.val == 0) {
      //       this.pricingRule = false;
      //       this.pricingRuleDisabled = true;
      //     } else {
      //       this.pricingRule = true;
      //       this.pricingRuleDisabled = false;
      //     }
      //   }
      //   //供应链主体
      //   if (obj.prop == 'supplychain') {
      //     this.params.supplychainNo = obj.val ? obj.val[0].supplierCode : null;
      //     this.params.supplychainName = obj.val ? obj.val[0].supplierName : null;
      //   }
      //   //定价规则  一口价
      //   if (obj.prop == 'pricingRule') {
      //     if (obj.val == 'DJ02') {
      //       this.$refs.product.upDataPricingRule();
      //     }
      //   }
      //   //币种
      //   if (obj.prop == 'contractCurrency') {
      //     this.params.contractCurrency = obj.val.currencyCode || this.params.companyCurrency;
      //     this.params.contractCurrencyName = obj.val.currencyName || this.params.companyCurrencyName;
      //     const params = {
      //       fromCurrencyCode: this.params.contractCurrency,
      //       toCurrencyCode: this.params.companyCurrency,
      //     };
      //     //如果没有本位币
      //     if (this.params.supplierNo == 'C0328') {
      //       this.params.contractCurrency = null;
      //       this.params.contractCurrencyName = null;
      //       this.$message({
      //         showClose: true,
      //         message: '请先配置公司帐套',
      //         type: 'error',
      //       });
      //       return;
      //     }
      //     //如果是本币
      //     if (obj.val.currencyCode == this.params.companyCurrency) {
      //       this.params.contractCurrencyExchangeRate = 1;
      //       return;
      //     }
      //     if (!params.toCurrencyCode) {
      //       return;
      //     }
      //     //增加入参汇率类型exchangeType: Cooperate  公司类型  User 用户类型，除收付款单据其他汇率日期exchangeDate取月初日期
      //     params.exchangeType = 'Cooperate';
      //     params.exchangeDate = this.$baseRequest.getBeginOfMonth(new Date());
      //     this.$axios.post(AGENCY_API.GET_CURRENCY_EXCHANGE, params).then((res) => {
      //       if (res.data.code === 0) {
      //         if (res.data.data) {
      //           this.params.contractCurrencyExchangeRate = res.data.data.positiveRate;
      //         }
      //       } else {
      //         this.$alert(res.data.msg);
      //         this.params.contractCurrencyExchangeRate = 1;
      //         this.params.contractCurrency = this.params.companyCurrency;
      //         this.params.contractCurrencyName = this.params.companyCurrencyName;
      //       }
      //     });
      //   }
      // },
      //设置不定价 或者 更新意向单总金额
      // changeTableData(obj) {
      //   if (obj.label === 'isFixedPrice') {
      //     if (obj.value == 1) {
      //       this.pricingRule = true;
      //       this.pricingRuleDisabled = false;
      //     }
      //     if (obj.value == 0) {
      //       this.pricingRule = false;
      //       this.pricingRuleDisabled = true;
      //     }
      //   }
      //   this.$refs.formItem.setSearchModal(obj.label, obj.value);
      // },
      //上传回调
      // handleUpload(uploadTableData) {
      //   this.uploadTableData = uploadTableData;
      // },
      // //保存
      // async handleSave(type) {
      //   if (type === '1') {
      //     let result = true;
      //     await this.$refs.upload.checkRequired().then((res) => {
      //       result = res;
      //     });
      //     if (!result) return;
      //   }
      //   const that = this;
      //   //基本信息-验证
      //   const base = this.$refs.formItem.submit(type);
      //   //产品明细-验证
      //   const product = this.$refs.product.submit(type);
      //   //获取产品明细
      //   const goodsList = this.$refs.product.getValues();
      //   //如果是提交  需要校验商品行项目
      //   if (goodsList.length == 0) {
      //     this.$message({
      //       showClose: true,
      //       message: this.$t('xTable.saveNoData'),
      //       type: 'error',
      //     });
      //     return;
      //   }
      //   Promise.all([base, product]).then(async () => {
      //     that.load = true;
      //     // 获取基础信息值
      //     const baseData = this.$refs.formItem.getValues();
      //     //purchase 采购 sales 销售
      //     baseData.contractCategory = 'sales';
      //     //制单类型
      //     baseData.contractDetailCategory = this.$route.query.type;
      //     //0 保存  1 提交
      //     baseData.type = type;
      //     //商品行项目
      //     baseData.orderDetailList = goodsList;
      //     //订单关联明细
      //     baseData.orderContractRelationshipList = this.$refs.relationInfo.getValues();
      //     //附件信息
      //     const attachment = that.uploadTableData.map((item, index) => {
      //       const result = Object.assign(
      //         {},
      //         {
      //           sortNo: index,
      //         },
      //         item
      //       );
      //       return result;
      //     });
      //     //附件信息
      //     baseData.attachmentList = attachment;
      //     //备注
      //     baseData.mark = this.remark.mark;
      //     //增加dataGroup zjmj
      //     baseData.dataGroup = this.$globalVar.dataGroup;
      //     let checkParams = {
      //       id: baseData.id,
      //       dataGroup: this.$globalVar.dataGroup,
      //       externalContractNo: baseData.externalContractNo,
      //       contractCategory: 'sales',
      //       //itemType : baseData.externalContractNo,
      //     };
      //     const p1 = await CHECK_EXTERNAL_CONTRACTNO(checkParams);
      //     that.load = false;
      //     if (!p1) return;
      //     let flag = false;
      //     if (baseData.orderDetailList.length != 0) {
      //       baseData.orderDetailList.forEach((item) => {
      //         if (Number(item.monthProductQuantity) > Number(item.yearProductQuantity)) {
      //           flag = true;
      //         }
      //       });
      //     }
      //     if (flag) {
      //       this.$message({
      //         showClose: true,
      //         message: this.$t('salePurchase.productMounthYear'),
      //         type: 'error',
      //       });
      //       this.load = false;
      //       return;
      //     }
      //     that.saveConfirm(baseData, type);
      //   });
      // },
      // saveConfirm(baseData, type, cancelValidate = false) {
      //   let that = this;
      //   baseData.cancelValidate = cancelValidate;
      //   this.$axios.post(API.SAVE_ORDER_API, baseData).then((res) => {
      //     that.load = false;
      //     if (0 != res.data.code) {
      //       if (!res.data.data) {
      //         this.$reportErrors({
      //           msg: res.data.msg,
      //           code: res.data.code,
      //           callback: () => {
      //             //确认提交，cancelValidate传值true取消校验
      //             this.saveConfirm(baseData, true);
      //           },
      //         });
      //       } else {
      //         this.$alert(res.data.msg);
      //         this.dblclickEvent(res.data.data);
      //       }
      //       //that.$alert(res.data.msg);
      //     } else {
      //       if (type == '0') {
      //         that.dblclickEvent(res.data.data);
      //       } else {
      //         that.cancel(false);
      //       }
      //       that.$message({
      //         showClose: true,
      //         message: res.data.msg || that.$t('message.success'),
      //         type: 'success',
      //       });
      //     }
      //   });
      // },
      //保存--修改
      // dblclickEvent(value) {
      //   let path = {
      //     fromPath: {
      //       path: '/salePurchase/yearSale',
      //       name: 'yearSale',
      //       meta: {
      //         keepAlive: true,
      //         title: '年度销售协议创建',
      //       },
      //     },
      //     toPath: {
      //       path: '/salePurchase/yearSaleEdit',
      //       name: 'yearSaleEdit',
      //       meta: {
      //         keepAlive: false,
      //         title: this.$t('salePurchase.message.annualSalesAgreementModification'),
      //       },
      //       query: {
      //         id: value.id,
      //         type: value.contractDetailCategory,
      //         contractNo: value.contractNo,
      //         contractCategory: 'sales',
      //         isEdit: value.contractStatus === 'ZT03' ? true : false,
      //       },
      //     },
      //   };
      //   this.$store.dispatch('tagsView/backTabView', path).then(() => {
      //     this.$nextTick(() => {
      //       this.$router.push(path.toPath);
      //     });
      //   });
      // },
      // //跳转到列表页面
      // cancel(keepAlive) {
      //   let path = {
      //     fromPath: {
      //       path: '/salePurchase/yearSale',
      //       name: 'yearSale',
      //       meta: {
      //         keepAlive: true,
      //         title: this.$t('salePurchase.message.annualSalesAgreementAdd'),
      //       },
      //     },
      //     toPath: {
      //       path: '/salePurchase/saleOverview',
      //       name: 'saleOverview',
      //       meta: {
      //         keepAlive: keepAlive,
      //         title: this.$t('salePurchase.message.salesOverviewEnquiries'),
      //       },
      //       query: {
      //         contractDetailCategory: 'HT05',
      //       },
      //     },
      //   };
      //   this.$store.dispatch('tagsView/backTabView', path).then(() => {
      //     this.$nextTick(() => {
      //       this.$router.push(path.toPath);
      //     });
      //   });
      // },
    },
  };
</script>
<style lang="scss" scoped>
  .prodcut {
    margin-bottom: 11px;
    background-color: #fff;
  }

  .detail {
    padding-bottom: 0px;
  }

  .collapse-main-content {
    margin-bottom: 10px;
  }
</style>
